<template>
  <el-dialog
    title="批量一次认领"
    :visible.sync="dialogVisible"
    width="800px"
    append-to-body
    class="batchFirstClaimDialog"
    @close="close"
  >
    <base-form
      v-model="baseData"
      :options="baseDataOptions"
      ref="baseData"
      :rules="rules"
      @input="handleChangeBaseData"
      label-width="105px"
    ></base-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">{{ this.$t('receivablesManageList.button.cancel') }}</el-button>
      <el-button type="primary" @click="save">{{
        this.$t('receivablesManageList.button.determine')
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
  // import { mapState } from 'vuex';
  import baseForm from '@/components/form/base-form';
  import API from '@/api/capitalCenter/receivablesManage';
  import DataBaseAPI from '@/api/dataBase';
  export default {
    name: 'batchFirstClaimDialog',
    components: {
      baseForm,
    },
    data() {
      return {
        dialogVisible: false,
        baseData: {
          customerNo: null, // 客户
          customerName: null, // 客户名称
          claimPartnerNo: null, // 供应商
          claimPartnerName: null, // 供应商名称
          claimDepartmentNo: null, // 部门
          claimDepartmentName: null, // 部门名称
          receivedType: null, // 收款类别
          receivedDetailType: null, // 收款细类
          projectCode: null, // 项目编号
          projectName: null, // 项目名称
          settlementNo: null, // 结算单号
          salesOrderNo: null, // 销售合同号
          purchaseOrderNo: null, // 采购合同号
          settleBatchNo: null, // 结算批次
          //receivableSettlementNo: null, // 应收结算单结算批次
          // payableSettlementNo: null, // 应付结算单结算批次
          sysConfigFlag: null, // 系统配置标识 海宁：Y
          receivedTypeOptions: [],
        },
        ids: [],
        registerCompanyCode: null,
        isShowReceivedDetailType: false,
        receivedTypeOptions: [],
        settlementBusinessType: '',
        businessType: '',
      };
    },
    computed: {
      getBusinessCategory() {
        const map = {
          '01': '01',
          '02': '02',
          '03': '05',
          '04': '03',
          '05': '06',
        };
        return map[this.businessType];
      },
      baseDataOptions() {
        return [
          {
            // 收款类别
            type: 'select',
            options: this.receivedTypeOptions,
            label: '收款类别',
            prop: 'receivedType',
            required: true,
            span: 12,
          },
          ...(this.isShowReceivedDetailType
            ? [
                {
                  // 收款细类
                  type: 'select',
                  options: this.$baseRequest.getDictListMapByType('receivedDetailType'),
                  label: '收款细类',
                  prop: 'receivedDetailType',
                  required: true,
                  span: 12,
                },
              ]
            : []),
          {
            // 客户
            type: 'searchTable',
            prop: 'customerName',
            isMultiple: true,
            label: this.$t('receivablesManageDialog.receivablesManage.customerNo'),
            searchType: 'customer',
            currentValue: this.baseData.customerName,
            span: 12,
            // disabled:this.baseData.claimPartnerNo ? true : false,
            disabled: ['08', '14', '15'].includes(this.baseData.receivedType),
            // required: this.baseData.claimPartnerNo ? false : true,
            required: !['08', '14', '15'].includes(this.baseData.receivedType),
            extraData: {
              companyCode: this.registerCompanyCode,
            },
          },
          {
            // 供应商
            type: 'searchTable',
            prop: 'claimPartnerName',
            isMultiple: true,
            label: this.$t('receivablesManageDialog.receivablesManage.claimPartnerNo'),
            searchType: 'supplier',
            currentValue: this.baseData.claimPartnerName,
            span: 12,
            // disabled:  this.baseData.customerNo ? true : false,
            disabled: !['08', '14', '15'].includes(this.baseData.receivedType),
            // required: this.baseData.customerNo ? false : true,
            required: ['08', '14', '15'].includes(this.baseData.receivedType),
            extraData: {
              companyCode: this.registerCompanyCode,
              departmentCode: this.claimDepartmentNo,
            },
          },
          {
            // 部门
            type: 'select',
            options: this.departmentList,
            label: this.$t('receivablesManageDialog.receivablesManage.claimDepartmentNo'),
            prop: 'claimDepartmentNo',
            required: true,
            span: 12,
          },
          /* {
            // 部门
            type: 'searchTable',
            prop: 'claimDepartmentName',
            isMultiple: true,
            label: this.$t('receivablesManageDialog.receivablesManage.claimDepartmentNo'),
            searchType: 'companyDept',
            span: 12,
            required: true,
            currentValue: this.baseData.claimDepartmentName,
            extraData: {
              belongCompanyCode: this.registerCompanyCode,
              personName: this.userInfo.userName,
            },
          }, */

          {
            // 项目编号
            type: 'searchTable',
            prop: 'projectCode',
            isMultiple: true,
            label: '项目编号',
            searchType: 'commonProject',
            currentValue: this.baseData.projectCode,
            extraData: {
              businessCategory: this.getProjectBusinessCategory,
              projectCompanyNo: this.userInfo.companyCode,
              projectDepartmentNo: this.userInfo.departmentCode,
            },
            parseExtendMap: true,
            span: 12,
          },
          /**
           {
            // 项目编号
            type: 'searchTable',
            prop: 'projectCode',
            isMultiple: true,
            label: this.$t('receivablesManageDialog.receivablesManage.projectCode'),
            searchType: 'projectInitiation',
            currentValue: this.baseData.projectCode,
            extraData: {
              projectInitiationStatus: 'PIS05',
            },
            span: 12,
          }
           */
          ...(this.baseData.customerNo
            ? [
                {
                  // 应收结算单号
                  type: 'searchTable',
                  prop: 'settlementNo',
                  isMultiple: true,
                  label: this.$t('receivablesManageDialog.receivablesManage.settlementNo'),
                  searchType: 'receivableSettlement',
                  currentValue: this.baseData.settlementNo,
                  extraData: {
                    settlementStatusList: ['04', '06', '07'],
                    customerNo: this.baseData.customerNo,
                    companyCode: this.userInfo.companyCode,
                    departmentCode: this.userInfo.departmentCode,
                  },
                  parseExtendMap: true,
                  span: 12,
                },
              ]
            : [
                {
                  // 应付结算单号
                  type: 'searchTable',
                  prop: 'settlementNo',
                  isMultiple: true,
                  label: this.$t('receivablesManageDialog.receivablesManage.settlementNo'),
                  searchType: 'payableSettlement',
                  currentValue: this.baseData.settlementNo,
                  extraData: {
                    settlementStatusList: ['04', '06', '07'],
                    claimPartnerNo: this.baseData.claimPartnerNo,
                    companyCode: this.userInfo.companyCode,
                    departmentCode: this.userInfo.departmentCode,
                    settlementBusinessType: this.getBusinessCategory,
                  },
                  parseExtendMap: true,
                  span: 12,
                },
              ]),

          {
            // 销售管理号
            type: 'searchTable',
            prop: 'salesOrderNo',
            label: this.$t('receivablesManageDialog.receivablesManage.salesOrderNo'),
            searchType: 'commonContract',
            span: 12,
            isMultiple: true,
            // disabled: !this.baseData.customerNo || !this.baseData.claimDepartmentNo,
            disabled: ['08', '14', '15'].includes(this.baseData.receivedType),
            currentValue: this.baseData.salesOrderNo,
            extraData: {
              businessCategory: this.getBusinessCategory,
              contractCategory: 'sales',
              contractCompanyNo: this.userInfo.companyCode,
              contractDepartmentNo: this.userInfo.departmentCode,
              // customerNo: this.baseData.customerNo,
              // contractStatus: 'ZT03',
              // contractDetailCategory: 'CG04',
              // contractCategory: 'sales',
              // contractBusinessDepartment: this.baseData.claimDepartmentNo,
            },
            parseExtendMap: true,
          },
          {
            // 采购管理号
            type: 'searchTable',
            prop: 'purchaseOrderNo',
            label: this.$t('receivablesManageDialog.receivablesManage.purchaseOrderNo'),
            searchType: 'commonContract',
            span: 12,
            isMultiple: true,
            currentValue: this.baseData.purchaseOrderNo,
            // disabled: !this.baseData.claimPartnerNo || !this.baseData.claimDepartmentNo,
            disabled: !['08', '14', '15'].includes(this.baseData.receivedType),
            extraData: {
              businessCategory: this.getBusinessCategory,
              contractCategory: 'sales',
              contractCompanyNo: this.userInfo.companyCode,
              contractDepartmentNo: this.userInfo.departmentCode,
              // supplierNo: this.baseData.claimPartnerNo,
              // contractStatus: 'ZT03',
              // contractCategory: 'purchase',
              // contractDetailCategory: 'CG01',
              // contractBusinessDepartment: this.baseData.claimDepartmentNo,
            },
            parseExtendMap: true,
          },
          /* {
            // 销售管理号
            type: 'searchTable',
            prop: 'settleBatchNo',
            label: this.$t('receivablesManageDialog.receivablesManage.settleBatchNo'),
            searchType: 'settle',
            span: 12,
            isMultiple: true,
            disabled: !this.baseData.claimDepartmentNo,
            currentValue: this.baseData.settleBatchNo,
            extraData: {
              settleDepartmentNo: this.baseData.claimDepartmentNo,
            },
          }, */
          //如果是海宁的增加业务属性选择，自营或者代理
          ...(this.sysConfigFlag == 'Y'
            ? [
                {
                  // 业务属性
                  type: 'select',
                  options: this.$baseRequest.getDictListMapByType('hn_order_businessType'),
                  label: '业务属性',
                  prop: 'businessType',
                  required: true,
                  span: 12,
                },
              ]
            : []),
        ];
      },
      rules() {
        return {};
      },
      isWuMaoAccount() {
        return ['物贸', '国贸'].includes(this.userInfo.businessGroup);
      },
      getProjectBusinessCategory() {
        if (this.userInfo.businessGroup == '城矿') {
          return '01';
        } else if (this.userInfo.businessGroup == '物贸') {
          return '02';
        } else if (this.userInfo.businessGroup == '国贸') {
          return '02';
        } else if (this.userInfo.businessGroup == '多式联运') {
          return '03';
        } else if (this.userInfo.businessGroup == '园区') {
          return '04';
        } else {
          return '';
        }
      },
    },
    methods: {
      async getSysConfigByCompany(companyCode) {
        // 系统配置判断
        let res = await this.$baseRequest.getSysConfigByCompany({
          code: 'FUND_COLLECTION_HN',
          companyCode,
        });
        if (res) {
          this.sysConfigFlag = res;
        }
      },
      async getDepartment() {
        // 取一级部门的最后一级部门
        if (this.registerCompanyCode) {
          let params = {
            id: this.userInfo.userCode,
            userCode: this.userInfo.userCode,
            personName: this.userInfo.userName,
            personCompanyCode: this.registerCompanyCode,
          };
          const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
          if (selectStatus.data.code == 0) {
            this.departmentList = selectStatus.data.data.personDepartmentInfo.map((item) => {
              return {
                ...item,
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });
            if (this.departmentList.length == 0) {
              this.$message({ showClose: true, message: '缺少对应部门，请维护', type: 'error' });
            }
          }
        } else {
          this.departmentList = [];
        }
      },
      handleChangeBaseData(value, prop) {
        if (prop == 'customerName' || prop == 'claimPartnerName') {
          let propNo = prop.replace('Name', 'No');
          this.searchTableChange(value[prop], [
            { val: prop, getVal: 'partnerZhName' },
            { val: propNo, getVal: 'partnerCode' },
          ]);
          this.baseData.salesOrderNo = this.baseData.purchaseOrderNo = null;
          this.baseData.settlementNo = null;
        } else if (prop == 'claimDepartmentNo') {
          /* this.searchTableChange(value[prop], [
            { val: prop, getVal: 'createDepartmentName' },
            { val: 'claimDepartmentNo', getVal: 'createDepartmentCode' },
          ]); */
          this.baseData.claimDepartmentName = value
            ? this.departmentList.find(
                (item) => item.personDepartmentCode == this.baseData.claimDepartmentNo
              ).personDepartmentName
            : null;
          this.baseData.salesOrderNo =
            this.baseData.purchaseOrderNo =
            this.baseData.settleBatchNo =
              null;
        } else if (prop == 'salesOrderNo' || prop == 'purchaseOrderNo') {
          this.searchTableChange(value[prop], [{ val: prop, getVal: 'contractNo' }]);
        } else if (prop == 'settleBatchNo') {
          this.searchTableChange(value[prop], [{ val: prop, getVal: 'settleNo' }]);
        } else if (prop == 'projectCode') {
          this.searchTableChange(value[prop], [
            { val: prop, getVal: 'projectInitiationNo' },
            { val: 'projectName', getVal: 'projectName' },
          ]);
        } else if (prop == 'settlementNo') {
          this.baseData.customerNo
            ? this.searchTableChange(value[prop], [{ val: prop, getVal: 'receivableSettlementNo' }])
            : this.searchTableChange(value[prop], [{ val: prop, getVal: 'payableSettlementNo' }]);
        } else if (prop == 'receivedType') {
          // 收款类别
          console.log(value[prop], '11111');
          if (['08', '14', '15'].includes(value[prop])) {
            this.baseData.customerName = null;
            this.baseData.customerNo = null;
          } else {
            this.baseData.claimPartnerName = null;
            this.baseData.claimPartnerNo = null;
          }
        }
      },
      searchTableChange(val, fooArr) {
        if (val && val.length > 0) {
          fooArr.map((item) => {
            if (item.getVal) {
              this.baseData[item.val] = val[0][item.getVal];
            } else {
              this.baseData[item.val] = val[0][item.val];
            }
          });
        } else {
          fooArr.map((item) => {
            this.baseData[item.val] = null;
          });
        }
      },
      // 打开
      async openDialog(flag, ids, val) {
        console.log(flag, ids, val, '========>>>>');
        this.receivedTypeOptions = [];
        this.businessType = val.businessType;
        if (val.businessType == '01') {
          this.receivedTypeOptions = this.$baseRequest.getDictListMapByType('receivedType');
          //【ID1002141】海宁收款认领增加类别  收款一次认领类别增加“预收账款”
          this.sysConfigFlag = await this.$baseRequest.getSysConfigByCompany({
            code: 'FUND_COLLECTION_HN',
            companyCode: val.registerCompanyCode,
          });
          if (this.sysConfigFlag == 'Y') {
            this.receivedTypeOptions.push({ label: '预收账款', value: 'RT17' });
          }
        } else if (val.businessType == '02') {
          console.log('多式联运下拉框', this.dictListMap.multimodalTransportReceivedType);
          this.receivedTypeOptions = this.dictListMap.multimodalTransportReceivedType;
        } else if (val.businessType == '03') {
          console.log('园区仓储下拉框');
          this.receivedTypeOptions = this.dictListMap.warehouseContractGuizhongLoadExpenseList;
        } else if (val.businessType == '04') {
          console.log('园区物业下拉框');
          this.receivedTypeOptions = this.dictListMap.parkReceivedType;
        } else if (val.businessType == '05') {
          console.log('监管单下拉框');
          this.receivedTypeOptions = this.dictListMap.parkReceivedType;
        } else {
          console.log(val.businessType, '等待开发中');
          this.receivedTypeOptions = [];
        }

        this.dialogVisible = flag;
        this.ids = ids;
        this.registerCompanyCode = val.registerCompanyCode;
        // 实时获取合作伙伴类型
        console.log(val);
        await this.getDepartment();
        let params = {
          payerName: val.payerName,
          payerCode: val.payerCode,
          registerCompanyCode: val.registerCompanyCode,
        };
        val.payerType = await this.$baseRequest.getPartnerType(params);
        this.isShowReceivedDetailType = val.businessType == '01' ? true : false;
        if (val.payerType == 'HZHB01' || val.payerType == 'HZHB03') {
          this.baseData.customerNo = val.payerCode;
          this.baseData.customerName = val.payerName;
        } else if (val.payerType == 'HZHB02') {
          this.baseData.claimPartnerNo = val.payerCode;
          this.baseData.claimPartnerName = val.payerName;
        } else {
          this.dialogVisible = false;
        }
      },
      // 关闭
      close() {
        this.dialogVisible = false;
        this.ids = [];
        for (let item of Object.keys(this.baseData)) {
          this.baseData[item] = null;
        }
      },
      // 保存
      async save() {
        let fundCollectionFirstClaim = this.exportChildData();
        if (fundCollectionFirstClaim) {
          let params = {
            ids: this.ids,
            fundCollectionFirstClaim,
          };
          this.saveData(params);
        }
      },
      async saveData(params) {
        // 保存
        this.loading.startLoading();
        this.$axios
          .post(API.BATCHSAVE_COLLECTIONCLAIM_FIRST, { ...params, overAmountVerification: 'Y' })
          .then((res) => {
            this.loading.endLoading();
            if (res.data.code == 0) {
              this.$message({ showClose: true, type: 'success', message: res.data.msg });
              this.close();
              this.$emit('getNoCheckData');
            } else {
              this.dialogVisible = false;
              this.$confirmAction(res.data.msg, this.$t('receivablesManage.message.save'))
                .then(() => {
                  this.loading.startLoading();
                  this.$axios
                    .post(API.BATCHSAVE_COLLECTIONCLAIM_FIRST, {
                      ...params,
                      overAmountVerification: 'N',
                    })
                    .then((res) => {
                      this.loading.endLoading();
                      if (res.data.code == 0) {
                        this.$message({ showClose: true, type: 'success', message: res.data.msg });
                        this.close();
                        this.$emit('getNoCheckData');
                      } else {
                        this.$message({ showClose: true, type: 'error', message: res.data.msg });
                      }
                    });
                })
                .catch(() => {
                  this.dialogVisible = true;
                  this.$message({
                    showClose: true,
                    type: 'info',
                    message: this.$t('confirm.deleteCancelled'),
                  });
                });
            }
          });
      },
      // 返回数据
      exportChildData() {
        // 点击提交，走校验
        let sign = false;
        this.$refs.baseData.$refs.ruleForm.validate((valid) => {
          if (valid) {
            sign = true;
          } else {
            sign = false;
          }
        });
        return sign ? this.baseData : false;
      },
    },
  };
</script>
<style lang="scss" scoped>
  ::v-deep.batchFirstClaimDialog {
    // text-align: center;
    .el-dialog__body {
      padding: 30px 130px 12px 50px;
      .el-select,
      .el-input {
        width: 100%;
      }
    }
    .el-dialog__footer {
      text-align: center;
    }
  }
</style>
